import { Component, OnInit, AfterViewInit, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import * as _ from 'lodash';

import { Router } from '@angular/router';
import { PaymentService as PaymentLocalService } from '../../../services/payment/payment.service';
import { DateValidator } from './../../../validator/date-validator';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-subscription-card',
  templateUrl: './subscription-card.component.html',
  styleUrls: ['./subscription-card.component.scss']
})
export class SubscriptionCardComponent implements OnInit, AfterViewInit {

  packageId: any;
  isCameraPlanEnabled = false;
  plansData: any;
  subscriptionPlan: any;
  cameraPlan: any;
  spacePlan; any;
  taxPercentage = 0;

  paymentForm: FormGroup;
  expiryDate: FormGroup;
  errors = [];
  isSubmitted = false;
  isSubmitting = false;

  accessToken: any;
  isLoading: any;
  card = '';
  name = '';
  expDate = '';
  // tslint:disable-next-line:max-line-length
  // cCardNoRegex = '^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$';
  cCardNoRegex: any;
  mastCardRegex = '^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$';
  // mastCardRegex = '^%B(5[1-5][0-9]{14})\\^([A-Z ]+)/([A-Z ]+)(\\.[A-Z ]+)?\\^([0-9]{2})([0-9]{2})';
  visaCardRegex = '^4[0-9]{15}(?:[0-9]{3})?$';
  visaCardRegex1 = '^4[0-9]{14}(?:[0-9]{3})?$';

  discoverCardRegex = '^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)';
  jcbCardRegex = '^35(2[89]|[3-8][0-9])';
  amexCardRegex = '^3[47][0-9]{13}$';
  dinersCardRegex = '^3(?:0[0-5]|[68][0-9])[0-9]{11}$';
  cardHolderName = '^[a-zA-Z\s ]+$';
  expiryDateRegex = '^(0[7-9]|1[0-2])/(1[8-9])|(0[1-9]|1[0-2])/(2[0-9]|3[0-9])$';
  ccvCodeRegex = '^[0-9]{3,4}$';
  cardActiveClass: any;
  paymentData = {};

  paymentErrorMessage: any;

  constructor(private router: Router, private fb: FormBuilder, public paymentLocalService: PaymentLocalService, public ngZone: NgZone) {
    this.cCardNoRegex = this.visaCardRegex + '|' + this.visaCardRegex1 + '|' + this.discoverCardRegex + '|' + this.jcbCardRegex + '|' + this.amexCardRegex + '|' + this.dinersCardRegex + '|' + this.mastCardRegex;
    this.initializeForm();

    this.isCameraPlanEnabled = this.paymentLocalService.getCameraPlan() ? true : false;
    this.paymentLocalService.planDataSubscription.subscribe(response => {
      if (response) {
        this.plansData = response;
        this.subscriptionPlan  = _.find(this.plansData, {plan_type: 'subscription' }) ? _.find(this.plansData, {plan_type: 'subscription' }) : false;
        if (this.subscriptionPlan && this.subscriptionPlan.tax) {
          this.taxPercentage = this.subscriptionPlan.tax;
        }
        this.cameraPlan  = _.find(this.plansData, {plan_type: 'camera' });
        this.spacePlan  = _.find(this.plansData, {plan_type: 'space' });
      }
    });

  }

  ngOnInit() {
    const formData = this.paymentLocalService.getCardData();
    this.updateForm(formData);
  }

  ngAfterViewInit(): void {
    // SDK Payment initialiation
    Multipayment.init (environment.paymentApiKey);
  }

  initializeForm() {

    this.expiryDate = this.fb.group({
      month: new FormControl('', [Validators.required]),
      year: new FormControl('', [Validators.required])
    });

    this.paymentForm = this.fb.group({
      cardNumber: ['', [Validators.required, Validators.pattern(this.cCardNoRegex)] ],
      ccvCode: ['', [Validators.required, Validators.pattern(this.ccvCodeRegex)] ],
      expiryDate: this.expiryDate,
      nameOnCard: ['', [Validators.required, , Validators.pattern(this.cardHolderName)] ]
    }, {
      validator: [DateValidator.ExpiryDate]
    });
  }

  updateForm(formData) {
    this.paymentForm.reset({
      cardNumber : formData.cardNumber ? formData.cardNumber : '',
      ccvCode: formData.ccvCode ? formData.ccvCode : '',
      expiryDate : {
        month: formData.expiryDate ? formData.expiryDate.substr(0, 2) : '',
        year: formData.expiryDate ? formData.expiryDate.substr(3) : ''
      },
      nameOnCard : formData.nameOnCard ? formData.nameOnCard : '',
    });

    this.cardActiveClass = undefined;
    if (this.paymentForm.get('cardNumber').valid) {
      this.cardActiveClass = this.getCardType(this.paymentForm.get('cardNumber').value);
    }

  }

  getCardType(cardNumber) {
    // visa
    let re = new RegExp(this.visaCardRegex);
    if (cardNumber.match(re) != null) {
      return 'visa';
    }

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    re = new RegExp(this.mastCardRegex);
    if (cardNumber.match(re) != null) {
      return 'master';
    }

    // AMEX
    re = new RegExp(this.amexCardRegex);
    if (cardNumber.match(re) != null) {
      return 'amex';
    }

    // Discover
    re = new RegExp(this.discoverCardRegex);
    if (cardNumber.match(re) != null) {
      return 'discover';
    }

    // Diners
    re = new RegExp(this.dinersCardRegex);
    if (cardNumber.match(re) != null) {
      return 'dinersclub';
    }

    // Diners - Carte Blanche
    re = new RegExp(this.dinersCardRegex);
    if (cardNumber.match(re) != null) {
      return 'dinersclub';
    }

    // JCB
    re = new RegExp(this.jcbCardRegex);
    if (cardNumber.match(re) != null) {
      return 'jcb';
    }

    // Visa Electron
    re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
    if (cardNumber.match(re) != null) {
      return 'Visa Electron';
    }

    return '';
  }


  submitForm(value) {
    this.isSubmitted = true;
    if (!this.paymentForm.valid) {
      return;
    }

    if (this.isSubmitting) {
      return;
    }
    this.paymentErrorMessage = undefined;
    this.isSubmitting = true;

    const formData = _.cloneDeep(value);
    const cardObject = {
      cardno: formData.cardNumber,
      expire: formData.expiryDate.year + formData.expiryDate.month,
      securitycode: formData.ccvCode,
      holdername: formData.nameOnCard,
      tokennumber: 2
    };
    formData.expiryDate = formData.expiryDate.month + '/' + formData.expiryDate.year;
    delete formData.expiryDate.month;
    delete formData.expiryDate.year;

    Multipayment.getToken (cardObject, (response) => this.ngZone.run(() => {
      if (response.resultCode !== '000') {
        // show error message
        this.isSubmitted = false;
        this.isSubmitting = false;
        this.paymentErrorMessage = 'There was error while processing your card information';
      } else {
        // use this token instead of card details to create transactions
        if (response.tokenObject && response.tokenObject.token && Array.isArray(response.tokenObject.token) && response.tokenObject.token.length > 1) {
          formData.paymentToken = response.tokenObject.token[0];
          formData.registerToken = response.tokenObject.token[1];
          this.paymentLocalService.setCardData(formData);
          this.router.navigate(['/subscription/confirm']);
        } else {
          // show error message
          this.isSubmitted = false;
          this.isSubmitting = false;
          this.paymentErrorMessage = 'There was error while processing your card information';
        }
      }
    }));
  }

  getExpiryMonth() {
    const workingHour = this.paymentForm.get('expiryDate').get('month') as FormGroup;
    return workingHour;
  }

  getExpiryYear() {
    const workingHour = this.paymentForm.get('expiryDate').get('year') as FormGroup;
    return workingHour;
  }


}
